import React from 'react'
export default function DescriptionLine({line}) {
    console.log("Line "+line);
    return (
        <div>{line}<br/></div>
    )
}
